// RBAC permission keys returned by GET /me/permissions are flat strings shaped
// as "<product>:<resource>:<action>", e.g. "csr:dashboard:create". The product
// segment is the lower-cased study type used by the dashboard documents
// ("CSR", "LS", ...), so the keys can be derived from a row's study_type.

export const PERMISSION_ACTIONS = {
  read: "read",
  create: "create",
  delete: "delete",
  update: "update",
};

// The keys the frontend gates a control or a request on. Spelled out rather
// than built on the fly so a grep for a key finds both the gate and this list.
export const PERMISSIONS = {
  csrDashboardRead: "csr:dashboard:read",
  csrDashboardCreate: "csr:dashboard:create",
  csrDashboardDelete: "csr:dashboard:delete",
  csrFilesRead: "csr:files:read",
  csrFilesCreate: "csr:files:create",
  csrFilesUpdate: "csr:files:update",
  csrFilesDelete: "csr:files:delete",
  csrWizardsRead: "csr:wizards:read",
  csrWizardsUpdate: "csr:wizards:update",
  csrGenerationCreate: "csr:generation:create",
  csrGenerationUpdate: "csr:generation:update",
  csrDownloadsRead: "csr:downloads:read",
  lsDashboardRead: "ls:dashboard:read",
  lsDashboardCreate: "ls:dashboard:create",
  lsDashboardDelete: "ls:dashboard:delete",
  lsWizardsRead: "ls:wizards:read",
  lsWizardsUpdate: "ls:wizards:update",
  lsGenerationCreate: "ls:generation:create",
  // The lay summary product spells its download permission as a generation
  // read, where CSR uses csr:downloads:read.
  lsGenerationRead: "ls:generation:read",
};

// Shown on a control that is disabled because the user lacks its permission.
export const NO_PERMISSION_TITLE =
  "You do not have permission for this action. Please contact the TriloDocs Team.";

export const permissionKey = (product, resource, action) =>
  `${String(product).toLowerCase()}:${resource}:${action}`;

export const dashboardPermission = (studyType, action) =>
  permissionKey(studyType, "dashboard", action);

// Labels for the dashboard type filter buttons. Types that are not listed here
// fall back to their raw code so a newly added product still gets a usable
// button rather than a blank one.
export const STUDY_TYPE_LABELS = {
  CSR: "Clinical study reports",
  LS: "Lay summaries",
};

export const studyTypeLabel = studyType =>
  STUDY_TYPE_LABELS[studyType] || studyType;

// Preferred display order for the filter buttons; anything else keeps the
// alphabetical order applied after these.
const STUDY_TYPE_ORDER = ["CSR", "LS"];

export const sortStudyTypes = studyTypes =>
  [...studyTypes].sort((a, b) => {
    const aIndex = STUDY_TYPE_ORDER.indexOf(a);
    const bIndex = STUDY_TYPE_ORDER.indexOf(b);
    if (aIndex !== -1 || bIndex !== -1) {
      if (aIndex === -1) return 1;
      if (bIndex === -1) return -1;
      return aIndex - bIndex;
    }
    return a.localeCompare(b);
  });
